const firebaseConfig = {
  apiKey: "AIzaSyBp0jyyIk3JT3HPwwLIHi4QDZRx_Ko-nfQ",
  authDomain: "camerashop-dcc0b.firebaseapp.com",
  projectId: "camerashop-dcc0b",
  storageBucket: "camerashop-dcc0b.appspot.com",
  messagingSenderId: "797258889587",
  appId: "1:797258889587:web:d31d652a2ebe532a6e6d06",
  measurementId: "G-F7ZT9KTFM3",
};
export default firebaseConfig;  